// ============================================================
// Mock data — users
// ============================================================
export const MOCK_USERS = [
  { id: 'u1', name: 'Xavi Soler',   initials: 'XS', role: 'admin',    title: 'Director de propuestas',       email: 'xavi.soler@impacthub.net',   hue: 200 },

  { id: 'u2', name: 'Marc Aldea',   initials: 'MA', role: 'redactor', title: 'Consultor sénior',             email: 'marc.aldea@impacthub.net',   hue: 30  },
  { id: 'u3', name: 'Bea Quintana', initials: 'BQ', role: 'revisor',  title: 'Especialista sector público',  email: 'bea.quintana@impacthub.net', hue: 320 },
  { id: 'u4', name: 'Ignacio Roa',  initials: 'IR', role: 'firmante', title: 'Director de consultoría',      email: 'ignacio.roa@impacthub.net',  hue: 130 },
  { id: 'u5', name: 'Sara Tobón',   initials: 'ST', role: 'redactor', title: 'Consultora junior',            email: 'sara.tobon@impacthub.net',   hue: 260 },
];

export const CURRENT_USER = {
  id: 'demo',
  name: 'Invitado · Admin',
  initials: 'IM',
  role: 'admin',
  title: 'Modo demo',
  email: 'demo@impacthub.net',
  hue: 180,
};
